import { useMutation } from '@tanstack/react-query';
import type { SubmitDemographicInfoRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSubmitDemographicInfo } from '../api/submitDemographicInfo.js';

export interface SubmitDemographicInfoVariables {
  data: SubmitDemographicInfoRequestT;
}

export function useSubmitDemographicInfoMutation() {
  return useMutation({
    mutationKey: ['dosespot-idp', 'submit-demographic-info'],
    mutationFn: async ({ data }: SubmitDemographicInfoVariables) => {
      return await fetchSubmitDemographicInfo(data);
    },
  });
}
